export const makeAnalyticsSourceID = v => v;